import React from 'react';

import { LottiePlayer } from '@src/components/atoms/lottie-player';
import { Heading4 } from '@src/theme';
import { noItemsFound } from '@src/theme/assets/animations';
import { bemClassName } from '@src/utils/bem';
import { lottieDefaultOptions } from '@src/utils/settings';

import { StyledNoItemsFound } from './styles';

const b = bemClassName('no-items-found');

const NoItemsFound = ({ title = 'Sorry, no items found' }) => {
  return (
    <StyledNoItemsFound>
      <div className={b()}>
        {title && <Heading4>{title}</Heading4>}
        <LottiePlayer animationData={noItemsFound} options={lottieDefaultOptions} speed={1.2} />
      </div>
    </StyledNoItemsFound>
  );
};

export default NoItemsFound;
